import React from 'react';
import AnimatedLogo from '../components/AnimatedLogo';
import './AboutPage.css';
import InfoCardSection from '../components/InfoCardSection'; // --- 1. Import the new section ---



const AboutPage = () => {
  const visionCopy = "WELCOME TO SHAPEFX WHERE CREATIVITY ORBITS";

  return (
    <div className="about-page-container">
      
      <section className="about-hero-section">
        {/* --- ADDITION: The Planet Arc Element --- */}
        <div className="bottom-planet-arc"></div>

        <div className="side-text-block text-left">
          <h2 className="side-text-main">BUILD</h2>
          <h2 className="side-text-secondary">DISCOVER</h2>
        </div>
        
        <div className="background-text">SHAPEFX</div>
                
        <AnimatedLogo />

        <div className="side-text-block text-right">
          <h2 className="side-text-main">CREATE</h2>
          <h2 className="side-text-secondary">CONNECT</h2>
        </div>

        <div className="vision-text-container">
          <p>{visionCopy}</p>
        </div>
      </section>

      <InfoCardSection />


    </div>
  );
};

export default AboutPage;
